<template>
    <div class="c-result-stat-correct">
        <div class="wr-result-stat-correct-labels">
            <svg class="c-result-stat-correct__icon" width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.252.912L7.062 11.103l-4.66-4.66a1.407 1.407 0 00-1.99 1.99l5.654 5.655a1.403 1.403 0 001.99 0L19.242 2.902a1.407 1.407 0 00-1.99-1.99z" fill="#708BB1"/></svg>
            <span class="c-result-stat-correct__label">DOĞRU</span>
        </div>
        <div class="wr-result-stat-correct-value">
            <span class="c-result-stat-correct__value">x{{correctValue}}</span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            correctValue: { type: Number, default: 4 }
        }
    };
</script>

<style scoped src="@/css/components/c-result-stat-correct.css"></style>